import React from 'react'
import styled from 'styled-components'
import Card from './Card'
import { InnerLayout } from './Layout'
import check from '../../Assets/img/check.svg';
import checkDisabled from '../../Assets/img/check-disabled.svg';
import DetailCard from './DetailCard';
import { Container } from "react-bootstrap";
import Particle from "../Particle";

import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";


const JusticeTechCard = () => {

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("/courses"); // This will navigate to the "/another-page" route
  };
    
    return (
        <Container >
      <ParticleWrapper>
                <Particle />
            </ParticleWrapper>
      <PaymentStyled id='pricing'>
         <InnerLayout>
            <div data-aos='fade-down-right'>
               <h3 className="small-heading">
                  Justice and Technology Course
               </h3>
               <p className="c-para">Designing Technology with Justice at Its Core </p>
               <p>The Justice and Technology Course invites youth and adults to explore justice as both a human virtue and a guiding principle for technology development and use. Justice enables participants to act with fairness, resist prejudice, and avoid extremes of thought and behavior. In today’s digital age, where technology shapes nearly every aspect of life, understanding justice is essential for designing tools that meet human needs, foster unity, and promote flourishing societies.
                  Through interactive activities, case studies, and project-based learning, participants reflect on justice as a moral compass, investigate the social impacts of technology, and design solutions that embody fairness, inclusivity, and ethical innovation.</p>
                  <p>Program Organization</p>
                  <p>The course is structured around developing the capability to think, act, and apply purposefully within the sphere of technology. Participants acquire concepts, relevant information, and skills, while cultivating attitudes and moral qualities necessary for effective and ethical participation in tech development and use.</p>
                  <p>The program emphasizes three main areas:

                  <li>Language & Reflection: Understanding justice and ethical reasoning in technology.</li>
                  <li>Technology Development: Applying principles of fairness and inclusivity in tech creation.</li>
                  <li>Community Life: Designing solutions that promote the well-being of individuals and communities.</li>

                  By participating, youth develop capabilities crucial for becoming ethical tech innovators and promoters of community welfare.</p>
            </div>
            <Button onClick={handleClick}>View Trainings</Button>
            <div className='card-con'>
               <Card
                  account={'What You’ll Learn'}                 
                  text={'This course cultivates an understanding of justice as a guiding human capacity, encourages youth to critically reflect on its influence in technology, and empowers them to design, use, and advocate for innovations that serve humanity.'}
                  button={'Register Here'}
              
                  link="https://docs.google.com/forms/d/e/1FAIpQLSfyUZt4peUyGezMs72Taa9NH0s-IayV7VJpHF8kV7YQbZ1tpg/viewform"
                //   active={active}
                //   inactive={inactive}
                  check={check}
                  checkDis={checkDisabled}
                  text1={'Define and articulate justice as a virtue and describe its role in society and technology. Analyze how technologies reflect values and how injustice can manifest in digital tools, platforms, and systems.'}
                  text2={'Reflect on moderation in personal technology use and propose ways to regulate excess through wisdom and justice.'}
                  text3={'Apply ethical frameworks to assess whether technologies meet the real needs of communities and humanity.'}
                  text4={'Recognize the interconnectedness of individuals and communities and explain how technology can strengthen or undermine unity. '}
                  text5={'Develop critical thinking skills to independently investigate information and resist blind imitation or prejudice online.'}
                  text6={'Design solutions (apps, campaigns, initiatives, or policies) that embody justice, fairness, and inclusivity. Collaborate with peers to create a collective charter of principles for just technology use and innovation.'}
                
               />

               <Card
                  account={'Payment'}
                  amount={'$99.99'}
                  text={'A seamless and user-friendly payment integration.'}
                button={'Pay Here'}
                link="https://checkout.square.site/merchant/MLAY6G9T625V1/checkout/BJTDAYSW5WSLADJBUJL7UXET"
                
                //   active={active}
                //   inactive={inactive}
                  check={check}
                  checkDis={checkDisabled}
                  text1={'Course Length: 10 hours.'}
                  text2={'Experience: No experience needed. A desire to explore ethical technology and justice in digital spaces.'}
                  text3={'Certification: Certificate awarded upon completion.'}
                  text4={'Course Setting: Remote.'}
                  text5={'Software Requirements: No paid software required.'}
                  text6={'Course Requirements: Access to a computer and internet. Openness to diverse perspectives, ethical reasoning, and collaborative problem-solving.'}
         
                 />

           </div>
         </InnerLayout>
            </PaymentStyled>
            <Container>
                <DetailCard/>
                </Container>
            </Container>
      
   )
}

const ParticleWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;  // Place it behind all other content
`;

const PaymentStyled = styled.section`
 .card-con {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 2rem; /* Reduce the gap between the cards */
    padding-top: 4rem; /* Reduce top padding */
    
    /* Optional: Use max-width to control the card's maximum size */
    max-width: 1200px;
    margin: 0 auto;
        
    @media screen and (max-width: 689px) {
      grid-template-columns: 1fr; /* Stack cards on mobile */
    }
  }

  p {
    text-align: center;
  }
`



export default JusticeTechCard
